import { AiOutlineClose } from "react-icons/ai";
import { useState, useEffect } from "react";

const MobileSidebar = ({ sidebarOpen, setSidebarOpen }) => {
  const [activePage, setActivePage] = useState("");
  const [servicesOpen, setServicesOpen] = useState(false);

  useEffect(() => {
    setActivePage(window.location.pathname);
  }, []);

  return (
    <div
      className={`fixed top-0 left-0 h-full z-30 w-64 o bg-white shadow-lg transform ${
        sidebarOpen ? "translate-x-0" : "-translate-x-full"
      } transition-transform duration-300 ease-in-out md:hidden`}
    >
      {/* Sidebar Header */}
      <div className="flex justify-between items-center p-4 border-b">
        <span className="text-xl font-bold text-black">Menu</span>
        <button
          onClick={() => setSidebarOpen(false)}
          className="text-2xl text-black"
        >
          <AiOutlineClose />
        </button>
      </div>

      {/* Sidebar Links */}
      <nav className="flex flex-col space-y-2 p-4">
        <a
          href="/"
          className={`p-3 rounded-md hover:bg-gray-100 ${
            activePage === "/"
              ? "text-webOranage font-semibold bg-gray-100"
              : ""
          }`}
        >
          Home
        </a>
        <a
          href="/about-us"
          className={`p-3 rounded-md hover:bg-gray-100 ${
            activePage === "/about-us"
              ? "text-webOranage font-semibold bg-gray-100"
              : ""
          }`}
        >
          About Us
        </a>
        <a
          href="/contact-us"
          className={`p-3 rounded-md hover:bg-gray-100 ${
            activePage === "/contact-us"
              ? "text-webOranage font-semibold bg-gray-100"
              : ""
          }`}
        >
          Contact
        </a>
        <a
          href="/career"
          className={`p-3 rounded-md hover:bg-gray-100 ${
            activePage === "/career"
              ? "text-webOranage font-semibold bg-gray-100"
              : ""
          }`}
        >
          Career
        </a>

        {/* Services with Dropdown */}
        <div className="bg-gray-50 rounded-md">
          <button
            onClick={() => setServicesOpen(!servicesOpen)}
            className={`w-full text-left p-3 rounded-md flex justify-between items-center hover:bg-gray-100 ${
              activePage.includes("/services")
                ? "text-webOranage font-semibold bg-gray-100"
                : ""
            }`}
          >
            Services
            <span className="text-lg">{servicesOpen ? "▲" : "▼"}</span>
          </button>

          {servicesOpen && (
            <div className="flex flex-col bg-white mt-1 rounded-md shadow-md overflow-x-hidden overflow-y-scroll max-h-[180px]">
              <a
                href="/services"
                className={`px-4 py-2 hover:bg-gray-100 ${
                  activePage === "/Services"
                    ? "text-webOranage font-semibold bg-gray-100"
                    : ""
                }`}
              >
                Services
              </a>
              <a
                href="/website-development"
                className={`px-4 py-2 hover:bg-gray-100 ${
                  activePage === "/website-development"
                    ? "text-webOranage font-semibold bg-gray-100"
                    : ""
                }`}
              >
                Web Development
              </a>
              <a
                href="/android-development"
                className={`px-4 py-2 hover:bg-gray-100 ${
                  activePage === "/android-development"
                    ? "text-webOranage font-semibold bg-gray-100"
                    : ""
                }`}
              >
                Android Development
              </a>
              <a
                href="/uiux-designer"
                className={`px-4 py-2 hover:bg-gray-100 ${
                  activePage === "/ai-solutions"
                    ? "text-webOranage font-semibold bg-gray-100"
                    : ""
                }`}
              >
                Ui-UX
              </a>
              <a
                href="/custom-software-development"
                className={`px-4 py-2 hover:bg-gray-100 ${
                  activePage === "/custom-software-development"
                    ? "text-webOranage font-semibold bg-gray-100"
                    : ""
                }`}
              >
                Custom Development{" "}
              </a>
              <a
                href="/point-of-sale-development"
                className={`px-4 py-2 hover:bg-gray-100 ${
                  activePage === "/point-of-sale-development"
                    ? "text-webOranage font-semibold bg-gray-100"
                    : ""
                }`}
              >
                Point Of Sale
              </a>
              <a
                href="/crm-development
"
                className={`px-4 py-2 hover:bg-gray-100 ${
                  activePage === "/crm-development"
                    ? "text-webOranage font-semibold bg-gray-100"
                    : ""
                }`}
              >
                CRM Development
              </a>
            </div>
          )}
        </div>

        <a
          href="/blogs"
          className={`p-3 rounded-md hover:bg-gray-100 ${
            activePage === "/blogs"
              ? "text-webOranage font-semibold bg-gray-100"
              : ""
          }`}
        >
          Blog
        </a>
      </nav>
    </div>
  );
};

export default MobileSidebar;
